module.exports = __webpack_public_path__ + "static/media/36.dce79d30.png";